import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Stack, Typography, createTheme, useMediaQuery } from '@mui/material';
import './style.css';
import { datetimeFormatter } from '../../utils/datetimeFormatter';
import dayjs from 'dayjs';
import { isEmpty } from '../../utils/helper';

export const ReadOnlyBuildingDesignDetails = observer(({ details }) => {
  const theme = createTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const getData = (value) => {
    return isEmpty(value) ? '_' : value;
  };

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Stack spacing={4}>
        <Stack spacing={3}>
          <Grid rowGap={2} container justifyContent={'space-evenly'}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Orientation
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Building Typology
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Slab area limitations, if any
                  </Typography>
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.orientation)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.buildingTypology)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.slabAreaLimitations)}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Stack direction={'row'} width={'100%'} height={'100%'} spacing={4}>
                <Stack direction={'column'} spacing={2} sx={{ color: '#626A72', fontWeight: '500' }}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Occupancy Type
                  </Typography>
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Occupants
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Occupants Age Group
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Occupants Occupations
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Occupants Hobbies
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'end',
                    }}
                    component="p"
                  >
                    Vastu Compliance
                  </Typography>
                  {details?.vastuCompliance && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'end',
                      }}
                      component="p"
                    >
                      Vastu Requirements
                    </Typography>
                  )}
                </Stack>
                <Stack direction={'column'} spacing={2}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {getData(details?.occupancyType)}
                  </Typography>
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.occupants)}
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.occupantsAgeGroup)}
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.occupantsOccupations)}
                    </Typography>
                  )}
                  {details?.occupancyType === 'Personal Residence' && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.occupantsHobbies)}
                    </Typography>
                  )}
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: '700',
                      alignSelf: 'start',
                    }}
                    component="p"
                  >
                    {details?.vastuCompliance ? 'Yes' : 'No'}
                  </Typography>
                  {details?.vastuCompliance && (
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: '700',
                        alignSelf: 'start',
                      }}
                      component="p"
                    >
                      {getData(details?.vastuRequirements)}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Paper>
  );
});
